import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.5" y="23.2461" width="8" height="3" className="bar-fill" fill="currentColor" />
    <rect x="6.5" y="11.2461" width="16" height="3" className="bar-fill" fill="currentColor" />
    <rect x="6.5" y="5.24609" width="24" height="3" className="bar-fill" fill="currentColor" />
    <rect x="2.5" y="5.24609" width="2" height="2" className="dot-fill" fill="currentColor" />
    <rect x="2.5" y="11.2461" width="2" height="2" className="dot-fill" fill="currentColor" />
    <rect x="2.5" y="17.2461" width="2" height="2" className="dot-fill" fill="currentColor" />
    <rect x="2.5" y="23.2461" width="2" height="2" className="dot-fill" fill="currentColor" />
    <rect x="6.5" y="17.2461" width="12" height="3" className="bar-fill" fill="currentColor" />
  </svg>,
  'BarChartIcon'
);

export const BarChartIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.bar-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.dot-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
